import { Vue, Prop, Component } from 'vue-property-decorator';
import { NodeData } from 'store';
import WithVersionValidator from '@/modules/versioning/components/with-version-validator/with-version-validator-logic';
import NavigationItem from '../navigation-item/navigation-item-logic';

@Component({
    components: {
        'with-version-validator': WithVersionValidator,
        'navigation-item': NavigationItem
    }
})
export default class FilteredNavigationItems extends Vue {
    @Prop()
    readonly navigationData!: NodeData;
}
